/**
 * Created by aaikepae on 11/3/16.
 */

import React,{ useState } from "react"

import {generateLink, getActAsPartnerAccess} from '../../../common/utility/utils'
import {parseURL} from "../../../common/utility/link"
import NavItemHeaderNavigation from "./NavItemHeaderNavigation"
import RequestAccess from "./RequestAccess";
//import { ToastContext } from '../../../common/base/ToastContext'
import AccessRestricted from "./AccessRestricted";



export default class NavItem extends React.Component {
   // static contextType = ToastContext;

    constructor() {
        super();
        this.itemRef = React.createRef();
        this.toggleMenu = this.toggleMenu.bind(this);
    }


    componentDidUpdate(prevProps) {
        if (this.props.selected.item == prevProps.selected.item && this.props.selected.section != prevProps.selected.section) {
            this.indicate(this.props.selected.section, prevProps.selected.section);
        } else {
            this.indicate(this.props.selected.section);
        }
    }

    indicate(section, previousSection) {
        //remove old active state
        if (previousSection) {
            let el;
            try {
                el = this.itemRef.current.querySelector(`[data-link="${generateLink(previousSection)}"]`);
            } catch (e) {
            }
            if (el) {
                el.classList.remove("active");
            }
        }


        const indicator = this.itemRef.current?.querySelector(".arrow-indicator");
        if (!indicator) {
            return false
        }

        //add new active state
        //move indicator
        if (this.props.meta.name === "Modern Commerce") {
            indicator.style.display = "inline-block";
        } else if (!section) {
            indicator.style.display = "none";
            return
        } else {
            indicator.style.display = "inline-block";
        }

        var active_el = null;
        try {
            active_el = this.itemRef.current.querySelector(`[data-link="${generateLink(section)}"]`);
        } catch (e) {
            return false;
        }
        if (active_el) {
            //
            const top = active_el.offsetTop;
            indicator.style.top = (top + 5) + "px";
            //
            active_el.classList.add("active");
        }

    }


    toggleMenu(event) {
      //  const { showToast } = this.context;
        // console.log(this.context);
        // if (!showToast) {
        //     console.error("showToast is not defined in the context.");
        //     return;
        //   }
        // showToast({
        //     title: 'Operation Failed',
        //     bg: 'danger',
        //     message: 'An error occurred',
        //   });
        const targetElement = event.currentTarget.tagName === 'A' ? event.currentTarget : event.currentTarget.closest('a');

        if (targetElement) {
            const sub_ul = targetElement.parentElement.querySelector("ul");
            if (sub_ul) {
                const arrow = targetElement.querySelector('.arrow');
                arrow.classList.toggle('active');
                sub_ul.style.display = arrow.classList.contains('active') ? 'block' : 'none';
            }
        }
    
        event.stopPropagation();
        event.preventDefault();
        return false

    }


    _generateLink() {
        const {data, selected, config, toggle} = this.props;
        const items = data["items"];
        const active = selected.item && data["active"] || data["expand"] ? 'active' : null;
        const expandTopLevel = data.depth == 0 && data["config"] && data["config"]["expand"] !== undefined;
        

        const arrow = items && (data.depth > 0 || expandTopLevel) ?
            <span className="arrowContainer" onClick={this.toggleMenu}><span
                className={"arrow " + active}/></span> : null;

        let linkIcon = data["config"] && data["config"]["icon"] ?
            <span className={"nav-item-icon " + data["config"]["icon"]} data-sequence={data["sequence"]}/> : null;


        // if type is url, just generate a commen link
        if (data["type"] == "url") {

            // support internal url 
            if(data.content.startsWith("#!")){
                return <a href={data.content} >{data.title}</a>
            }

            const target = data["config"] && data["config"]["target"] ? data["config"]["target"] : "_blank";
            const class_name = target == "_blank" ? "hyperlink" : null;
            if (target && target !== "_self") {
                return <a href={data.content} target={target} className={class_name} rel="noopener noreferrer">{data.title}</a>
            }

            return <a href={data.content} className={class_name}>{data.title}</a>

        }

        if (data["type"] == "file") {
            const file_url = parseURL(data.content, config.location);
            return( 
                <>
                    <a href={file_url} target="_blank" className="hyperlink" rel="noopener noreferrer">{data.title}</a>
                </>
        )

        }

        const isAuthenticated = window.sessionStorage.getItem("isAuthenticated");
        if(((data['type'] === 'doc_popup' || data['type'] === 'doc_page') && !isAuthenticated) || (data['type'] === 'doc_popup' && getActAsPartnerAccess('request-access'))) {
            return( 
                <>
                  <AccessRestricted data={data} selected={selected} config={config} actAsPartner={getActAsPartnerAccess('request-access')}></AccessRestricted>
                </>
            )
        }
        if(data['type'] === 'doc_popup') {
                return( 
                    <>
                     <RequestAccess data={data} selected={selected} config={config}/>
                    </>
                )
        }
        
       if(data['type'] === 'doc_page') {
        const url = this.props.router.generateLink("my_apps");
            return <a href={url} data-depth={data.depth} data-tag="navigation-item"
            data-url={data["url"]} onClick={(event) => {
            }}>{linkIcon}{data.title}{arrow}</a>;
        }

        if (data["type"] || data["alternative"]) { //generate navigate item with sub_navigation

            const uri = data["alternative"] || data["url"];

            const url = this.props.router.generateLink(uri);

            return <a href={url} data-depth={data.depth} data-tag="navigation-item"
                      data-url={uri} onClick={(event) => {
                          if (this.props.router.mode === 'history') {
                            this.toggleMenu(event);
                            event.preventDefault();
                            this.props.router.queryString = uri;
                          }
                          toggle();
                      }}>{linkIcon}{data.title}{arrow}</a>;
        }

        return <a onClick={this.toggleMenu}>{linkIcon}{data.title}{arrow}</a>;
    }

    render() {
        const {data, selected, config, toggle, meta} = this.props;
         
        if (data) {
            let accessLevel = window.sessionStorage.getItem("accessLevel") ?? 0;
            if(JSON.parse(window.sessionStorage.getItem('actAsPartner'))) {
                accessLevel = 0;  
            }
            data["accessLevel"] = data["accessLevel"] ?? 0;
            if(data["accessLevel"] > parseInt(accessLevel)) {
                return <li/>;
            }

            /**
             * generate children
             */

            const active = selected.item && data["active"] ? 'active' : null;
            const deprecated = data.config && data.config.deprecated && ' deprecated' || '';

            let children = null;
            
            let items = data["items"];
            if (items) {
                const _children = items.map((item, index) => {
                    return <NavItem key={item.url || index} data={item} selected={selected} config={config}
                                    router={this.props.router} meta={this.props.meta} toggle={toggle} />
                });

                children = <ul style={{ display: active && 'block' }}>{_children}</ul>;
            }

            const linkEL = this._generateLink();

            const subNav = <NavItemHeaderNavigation data={data} selected={selected} config={config}
                                                    router={this.props.router} meta={this.props.meta} toggle={this.props.toggle} />;
            const expandValue = this.props.meta.name === "Modern Commerce" ? true : data.expand;

            return <li className={active + deprecated} ref={this.itemRef} data-url-type={data["type"]} data-expand={expandValue}>
                {linkEL}
                {subNav}
                {children}
            </li>
        } else {
            return <li/>;
        }
    }
}


